import axios from "../axios-instance";
import {
  SETTINGS_FETCH_START,
  SETTINGS_FETCH_SUCCESS,
  SETTINGS_FETCH_FAIL,
  SETTINGS_SAVE_START,
  SETTINGS_SAVE_SUCCESS,
  SETTINGS_SAVE_FAIL,
  SETTINGS_SYNC_ENV_START,
  SETTINGS_SYNC_ENV_SUCCESS,
  SETTINGS_SYNC_ENV_FAIL,
} from "../constants/systemSettings";

export const fetchSettings = () => (dispatch) => {
  dispatch({ type: SETTINGS_FETCH_START });
  axios
    .get("super-admin/settings")
    .then((res) => {
      dispatch({
        type: SETTINGS_FETCH_SUCCESS,
        payload: res.data.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: SETTINGS_FETCH_FAIL,
        payload: err.response?.data?.data,
      })
    );
};

export const saveSettings = (group, settings, onSuccess) => (dispatch) => {
  dispatch({ type: SETTINGS_SAVE_START });
  axios
    .post("super-admin/settings/save", { group, settings })
    .then((res) => {
      dispatch({ type: SETTINGS_SAVE_SUCCESS });
      if (onSuccess) onSuccess();
    })
    .catch((err) =>
      dispatch({
        type: SETTINGS_SAVE_FAIL,
        payload: err.response?.data?.data,
      })
    );
};

export const syncEnvFile = (group, onSuccess) => (dispatch) => {
  dispatch({ type: SETTINGS_SYNC_ENV_START });
  axios
    .post("super-admin/settings/sync-env", { group })
    .then((res) => {
      dispatch({ type: SETTINGS_SYNC_ENV_SUCCESS });
      if (onSuccess) onSuccess();
    })
    .catch((err) =>
      dispatch({
        type: SETTINGS_SYNC_ENV_FAIL,
        payload: err.response?.data?.data,
      })
    );
};
